import styled from '@emotion/styled'
import {
  GridCellBoldText,
  GridCellNormalText,
  GridCellSmallFadedText,
} from '../../../../ui_reusable/styles/VersatileGridUtils.styles'
import theme from '../../../../../styles/theme'

export const DriverNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  width: 100%;
  overflow: hidden;

  & > span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export const ActionsContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
`

export const TooltipWrapper = styled.span`
  width: 100%;
  display: inline-block;
`

export const GridCellBoldTextInvalid = styled(GridCellBoldText)`
  color: ${theme.colors.veryVeryVeryFadedText};
  text-decoration: line-through;
`

export const StashedDriverTag = {
  backgroundColor: '#FFE0E0',
  color: '#d32f2f', // Using direct color instead of theme reference for css prop
  border: '1px solid #ffcdd2',
}

type GridCellProps = {
  isInvalid?: boolean
}

export const ConditionalGridCellNormalText = styled(
  GridCellNormalText,
)<GridCellProps>`
  color: ${(props) =>
    props.isInvalid ? theme.colors.veryVeryVeryFadedText : 'inherit'};
`

export const ConditionalGridCellSmallFadedText = styled(
  GridCellSmallFadedText,
)<GridCellProps>`
  color: ${(props) =>
    props.isInvalid ? theme.colors.veryVeryVeryFadedText : 'inherit'};
`
